module.exports = __webpack_public_path__ + "img/graduation.31d6d003.jpg";